// extracted by mini-css-extract-plugin
module.exports = {"Arrow":"Arrow_Arrow__jQm7b","Arrow-left":"Arrow_Arrow-left__bhbpz","Arrow-right":"Arrow_Arrow-right__ssM1k","hidden":"Arrow_hidden__IyXl0"};